import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function PersonalizationApiIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" viewBox="0 0 40 40" fill="none" {...props}>
      <Box
        as="path"
        fill="currentColor"
        d="M12.45 5.14a16.669 16.669 0 0 1 10.19-1.596 1.668 1.668 0 0 1-.528 3.292 13.334 13.334 0 1 0 11.048 11.02 1.668 1.668 0 0 1 3.29-.535 16.67 16.67 0 0 1-8.84 17.508A16.668 16.668 0 0 1 3.54 22.615a16.668 16.668 0 0 1 8.91-17.474Zm7.503 7.313c.92 0 1.667.747 1.667 1.667v6.103l4.478 4.478a1.668 1.668 0 0 1-2.357 2.358l-4.478-4.479a3.335 3.335 0 0 1-.977-2.357V14.12c0-.92.747-1.667 1.667-1.667Zm8.099-5.721c.259-1.198 1.968-1.198 2.227 0l.128.587a2.962 2.962 0 0 0 2.272 2.274l.588.126c1.198.258 1.199 1.97 0 2.227l-.588.127a2.962 2.962 0 0 0-2.273 2.273l-.127.588c-.258 1.199-1.969 1.198-2.227 0l-.126-.588a2.962 2.962 0 0 0-2.273-2.273l-.588-.127c-1.198-.259-1.198-1.968 0-2.227l.588-.126a2.962 2.962 0 0 0 2.273-2.274l.126-.587Z"
      />
    </Icon>
  );
}
